import { useEffect, useState } from 'react';
var initState = {
  screenX: NaN,
  screenY: NaN,
  clientX: NaN,
  clientY: NaN,
  pageX: NaN,
  pageY: NaN
};
export default (function () {
  var _useState = useState(initState),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    var moveHandler = function moveHandler(event) {
      var screenX = event.screenX,
          screenY = event.screenY,
          clientX = event.clientX,
          clientY = event.clientY,
          pageX = event.pageX,
          pageY = event.pageY;
      setState({
        screenX: screenX,
        screenY: screenY,
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      });
    };

    document.addEventListener('mousemove', moveHandler);
    return function () {
      document.removeEventListener('mousemove', moveHandler);
    };
  }, []);
  return state;
});